
import React,{Component} from "react";

import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  FormSelect,
  Col,
  Row
} from "shards-react";
import { AtomSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import firebase from '../firebase';

import '../style.css'

export default class ShowUsername extends Component{

  constructor(props) {
    super(props);
  
    this.state = {selected_student:undefined,
                  class_list:[],
                  loading:false,
                  selected_class:undefined,
                  student_list:[],

                };

    this.getStyle = this.getStyle.bind(this);
    this.ChangeSelect = this.ChangeSelect.bind(this);
    this.get_class_list = this.get_class_list.bind(this);
    this.get_student_list = this.get_student_list.bind(this);
    this.onClassChange = this.onClassChange.bind(this);
  }

  

  ChangeSelect=(id)=>{
    this.setState({selected_student:id});
    var student_list = this.state.student_list;
    for(var i=0;i<student_list.length;i++){
        if(id === student_list[i].roll_no){
            this.props.onStudentChange(student_list[i]);      
        }
    }
    
  }

  onClassChange = (id)=>{
      this.setState({selected_class:id},this.get_student_list);
      this.props.onClassChange(id);
  }

  get_student_list=()=>{

      

      var class_name = this.state.selected_class;
      console.log(class_name);

      if(class_name===undefined || class_name==="Select Class" || class_name==="No Avaiable class"){
          return;
      }
      var that = this;

      this.setState({loading:true,student_list:[]});      
      firebase.firestore().collection('StudentList').doc(class_name).get().then(function(doc){
              var student_list = doc.data().students;
              console.log(student_list);
              that.setState({student_list:student_list,loading:false});
      }).catch(function(err){
        console.log(err);
        that.setState({loading:false});
      })
  }


  get_class_list = ()=>{
      var that = this;
      this.setState({loading:true});

      firebase.firestore().collection('ClassList').doc('list').get().then(function(doc){
          var class_list = doc.data().classes;
          class_list.shift();  //removes first element in array
          that.onClassChange(class_list[0]);
          that.setState({loading:false,class_list:class_list});
      }).catch(function(err){
          that.setState({loading:false});
          toast('Unable to get class list !', {containerId: 'A'});
      })
  }


  getStyle = (id,type) =>{
      
      if(this.state.selected_student===id){
          if(type==="background"){
            return {backgroundColor: '#4169e1'}
          }
          if(type==="word"){
            return {color: 'white'}
          }
      }

      if(type==="background"){
            return {backgroundColor: 'white'}
      }
      if(type==="word"){
            return {color: 'black'}
      }
    
  }

  componentDidMount(){
     this.get_class_list();
  }

  render(){
    return(
     <Card small className="mb-4 pt-3">
        <CardHeader className="border-bottom text-center">
        		<h4 className="mb-0">{"Class"}</h4>
        			<Col sm="12" className="d-flex mb-2 mb-sm-0" style={{marginTop: '5px'}}>
              			<Col md="12" className="form-group">
             				
                    <SelectClass onChangeHandler={(evt)=>{this.onClassChange(evt.target.value)}}
                                  loading={this.state.loading}
                                  class_list={this.state.class_list} />
            			</Col>
            		</Col>
   		 </CardHeader>
    <ListGroup flush className={"scroll_list-group"}>
    	
        
                                          {

                                              this.state.student_list.map((item,i)=>{
                                                             return (<StudentUser 
                                                                       key={i} 
                                                                       data={item} 
                                                                       ChangeSelect={this.ChangeSelect}
                                                                       getStyle={this.getStyle}
                                                                       />)
                                                })
                                           }
      
    </ListGroup>
  </Card>
      )
  }
}



class StudentUser extends Component{
    render(){

      var roll_no = this.props.data.roll_no;
      var avatar = this.props.data.url === null ? "https://png.pngtree.com/svg/20161212/f93e57629c.svg": this.props.data.url;
      var name = this.props.data.name;

      return (

      <ListGroupItem className="px-4"  style={this.props.getStyle(roll_no,'background')} onClick={()=>{this.props.ChangeSelect(roll_no)}}>
        <div className="progress-wrapper" style={this.props.getStyle(roll_no,'word')}>
          <Row>
          <div className="blog-comments__avatar mr-3">
            <img src={avatar} alt={name} />
          </div>
          <div>
            <strong className=" d-block mb-2">
              {name}
            </strong>
            <p className=" d-block mb-1">
              {"Roll No "+roll_no}
            </p>
          </div>
          </Row>
        </div>
      </ListGroupItem>

        )
    }
}


class SelectClass extends Component{
  render(){
    return(

        <Col sm="12" className="d-flex mb-2 mb-sm-0" style={{marginTop: '5px'}}>
                    <Col md="12" className="form-group">
              {
                this.props.class_list.length>0 &&
                <FormSelect onChange={this.props.onChangeHandler}>

                                          {

                                              this.props.class_list.map((item,i)=>{
                                                             return (<option key={i}>{item}</option>)
                                                })
                                           }
                </FormSelect>
              }
              {
                this.props.class_list.length===0 &&

                <FormSelect>
                  <option>No Avaiable class</option>
                </FormSelect>
              }
            </Col>
              
    </Col>

      )
  }
}


